import { Ability } from '@casl/ability'
import { initialAbility } from './config'

// Cached user data is presentation state, not authentication or authorization proof.
// The auth bootstrap replaces this initial ability with server-issued rules.
export default new Ability(initialAbility)
